import React from 'react';
import { Star, ShieldCheck, CreditCard, Send } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { CtaButton } from '../CtaButton';
import { offerItems, offerTotal } from '../../data/content';
import { siteConfig } from '../../data/siteConfig';
import { useLocalPrice } from '../../hooks/useLocalPrice';
import { allLocalShort } from '../../utils/localCurrency';
const payBadges = [{
  icon: ShieldCheck,
  label: 'Pago seguro con Stripe'
}, {
  icon: CreditCard,
  label: 'Tarjeta de crédito o débito'
}, {
  icon: Send,
  label: 'Entrega por email'
}];
const afterSteps = ['Pagas en 1 minuto con tu tarjeta', 'Te llega el kit a tu email al instante', 'Lo descargas y lo usas hoy mismo'];
export function OfferSection() {
  const local = useLocalPrice();
  return <section id="oferta" className="scroll-mt-4 bg-forest py-16 md:py-[90px]" data-id="element-146" data-mp="3iy3gkryfeqd4">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-147" data-mp="3ey2qga1ysqq8">
        <SectionHeading tone="dark" kicker="La oferta" icon={Star} title={<>
              Todo el kit, por menos de lo que
              <br className="hidden md:block" data-id="element-149" data-mp="1fk1yhmhzj5ox" /> cobras por <em data-id="element-150" data-mp="10ucqb7bh61f5">un par de paseos</em>
            </>} data-id="element-148" data-mp="3ezdwyhmsocl1" />
        <Reveal className="mx-auto mt-10 max-w-[640px] overflow-hidden rounded-[32px] bg-white text-ink shadow-[0_40px_80px_-30px_rgba(0,0,0,.6)]" data-id="element-151" data-mp="10s02wemy6yup">
          <div className="bg-tangerine py-3 text-center font-display text-sm font-bold uppercase tracking-[0.1em] text-white" data-id="element-152" data-mp="1tjjlpxfmuaw6">
            Precio de lanzamiento
          </div>
          <div className="px-5 pb-1.5 pt-6 md:px-[30px]" data-id="element-153" data-mp="1kid5lpgwb23g">
            <ul data-id="element-154" data-mp="1kjwl3duq9946">
              {offerItems.map(({
              icon: Icon,
              label,
              value
            }) => {
              const included = value === 'Incluidos';
              return <li key={label} className="flex items-center justify-between gap-4 border-b border-dashed border-line py-[13px] text-[14.5px] md:text-base" data-id="element-155" data-mp="91vkglir0lw4">
                    <span className="flex items-center gap-2.5 font-medium" data-id="element-156" data-mp="2fq5lptssz5ih">
                      <Icon className="h-[18px] w-[18px] shrink-0 text-tangerine" aria-hidden="true" data-id="element-157" data-mp="2at5evgo4pyqb" />
                      {label}
                    </span>
                    <span className={`whitespace-nowrap font-display font-semibold ${included ? 'uppercase text-forest' : 'text-muted'}`} data-id="element-158" data-mp="212arua326v3t">
                      {value}
                    </span>
                  </li>;
            })}
            </ul>
            <div className="flex justify-between gap-4 pb-1 pt-4 font-display font-bold text-muted" data-id="element-159" data-mp="1n2i7cwi4lb4a">
              <span data-id="element-160" data-mp="1i4zsyqlca3ow">Valor estimado si lo armaras por separado</span>
              <s className="whitespace-nowrap text-danger" data-id="element-161" data-mp="3hf82fhk8cqd9">{offerTotal}</s>
            </div>
          </div>
          <div className="bg-cream px-5 pb-8 pt-5 text-center md:px-[30px]" data-id="element-162" data-mp="3cihmqvcc7wsd">
            <p className="font-display text-[15px] font-semibold text-muted" data-id="element-163" data-mp="3kz03m9lxddtg">Hoy te lo llevas todo por</p>
            <p className="my-1.5 font-display text-[56px] font-extrabold leading-none tracking-[-0.03em] text-forest md:text-[78px]" data-id="element-164" data-mp="3oz0ke0why13o">
              <small className="mr-1.5 align-[0.95em] text-[0.38em] text-tangerine" data-id="element-165" data-mp="3tradtqwtljap">{siteConfig.priceCurrency}</small>
              {siteConfig.priceAmount}
            </p>
            <p className="mb-1.5 font-display text-base font-bold text-forest" data-id="element-166" data-mp="320e1qsil3ioh">
              {local ? `En tu moneda: ≈ ${local.long} (aprox.)` : allLocalShort}
            </p>
            <p className="mb-6 text-[15px] font-semibold text-tangerine" data-id="element-167" data-mp="3azhktwhr3y2z">
              Pago único · Se cobra en tu moneda · Acceso inmediato
            </p>
            <CtaButton size="lg" data-id="element-168" data-mp="3fx10n0u3kix1">¡Sí, quiero mi kit PASEO PRO!</CtaButton>
            <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-169" data-mp="q90eajqkmypa">
              {payBadges.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-line bg-white px-2.5 py-[5px] text-xs font-bold text-muted" data-id="element-170" data-mp="vappbzdsncdd">
                  <Icon className="h-[13px] w-[13px]" aria-hidden="true" data-id="element-171" data-mp="2d6hvwldee061" />
                  {label}
                </li>)}
            </ul>
            <ol className="mx-auto mt-[22px] flex max-w-[360px] flex-col gap-2 text-left" data-id="element-172" data-mp="285vc5eretqye">
              {afterSteps.map((step, i) => <li key={step} className="flex items-center gap-3 text-[15px] font-semibold text-forest" data-id="element-173" data-mp="2i5m7tjrpic02" data-mpi={i}>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-tangerine font-display text-sm text-white" data-id="element-174" data-mp="2vwrbcwy73ofo">
                    {i + 1}
                  </span>
                  {step}
                </li>)}
            </ol>
            <p className="mt-4 text-[14.5px] text-muted" data-id="element-175" data-mp="35t2rxz4tj0fx">
              Con <b data-id="element-176" data-mp="30xf0fd2v5v79">un solo cliente</b> que no cancele a último momento, el kit ya se pagó solo.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}